import { createSelector } from '@ngrx/store';

import { AppState } from '../states/app.state';
import { Baseline } from '../states/baseline.state';

const selectBaselineState = (state: AppState) => state.baseline;

export const getBaseline = createSelector(selectBaselineState, (state: Baseline) => state);
